import { useEffect } from "react";
import comms from "./comms";

function Logout({
  onLogout,
  userSettings,
  driverAuthData,
  selectedVehicle,
  routeDetails,
  socket,
}) {
  // Clear user data and redirect to login screen
  useEffect(() => {
    const performLogout = async () => {
      try {
        // Use props for user and vehicle information
        const routeId = routeDetails?.routeId;
        let vehicleId = driverAuthData?.dispatchData?.vehicleId;

        // Step 1: Unassign vehicle from route first (if required)
        if (driverAuthData?.dispatchData?.routeRequired) {
          console.log("should unassign vehicle from route");

          await new Promise((resolve) => {
            let settled = false;
            const finish = () => {
              if (!settled) { settled = true; resolve(); }
            };
            // Never let logout hang if the socket doesn't ack (offline / reconnecting).
            const timer = setTimeout(finish, 3000);
            // Unassign vehicle from route if we have route and vehicle information
            if (routeId && vehicleId && socket) {
              socket.emit('unassignVehicleFromRoute', {
                routeId,
                vehicleId,
                routeType: routeDetails?.type
              }, (response) => {
                clearTimeout(timer);
                if (response && response.success) {
                  console.log("Vehicle unassigned from route successfully");
                } else {
                  console.error("Failed to unassign vehicle from route:", response && response.error);
                }
                finish();
              });
            } else {
              clearTimeout(timer);
              if (!socket) console.warn("No socket connection available for vehicle unassignment");
              finish();
            }
          });
        }

        if (driverAuthData?.dispatchData?.shiftRequired) {
          console.log("should close shift");
          // Call shift close if we have driver and vehicle information
          if (driverAuthData?.driverId && driverAuthData?.dispatchData?.vehicleId) {
            try {
              await comms.closeShift(driverAuthData.driverId, driverAuthData?.dispatchData?.vehicleId);
              console.log("Shift closed successfully");
            } catch (error) {
              console.error("Failed to close shift:", error);
              // Continue with logout even if shift close fails
            }
          }
        }
      } catch (error) {
        console.error("Error during logout process:", error);
      }

      // Close socket connection if available
      if (socket && typeof socket.disconnect === "function") {
        try {
          socket.disconnect();
          console.log("Socket disconnected successfully");
        } catch (error) {
          console.error("Error disconnecting socket:", error);
        }
      }

      // Clear user-related localStorage items (except fleetCode and selectedVehicle)
      localStorage.removeItem("userSettings");
      localStorage.removeItem("selectedRouteId");
      localStorage.removeItem("selectedRoute");
      localStorage.removeItem("routeDetails");
      localStorage.removeItem("driverNumber");
      localStorage.removeItem("pin");
      // Trip/vehicle status belongs to the driver who just signed out, not to this
      // device — without this the next driver inherits their Busy/OffService state.
      comms.clearCurrentStatus();

      // Call the logout callback to update app state
      if (onLogout) {
        onLogout();
      }
    };

    performLogout();
  }, [onLogout, userSettings, selectedVehicle, routeDetails, socket, driverAuthData]);

  return null; // No UI required for logout
}

export default Logout;
